import { useTranslation } from 'react-i18next';
import { OU_LIST, DAY_FULL_KEYS } from '../data';
import { useBuilderContext } from '../context/BuilderContext';
import { useGdprOuKey } from '@/hooks/useOUs';

export function StepPublicar() {
  const { t } = useTranslation();
  const { form, source } = useBuilderContext();
  const isTemplate = source === 'templates';
  const gdprOuKey = useGdprOuKey();
  const isEuropaOnly = form.audienceOUs.length === 1 && !!gdprOuKey && form.audienceOUs[0] === gdprOuKey;
  const issues: string[] = [];
  if (!form.name)                                         issues.push(t('admin.builderValidationName'));
  if (!form.expirationDate)                               issues.push(t('admin.builderValidationEndDate'));
  if (form.questions.length === 0)                        issues.push(t('admin.builderValidationNoQuestions'));
  if (form.surveyType === 'personalizada' && form.destMode === 'meeting' && !form.sessionId) issues.push(t('admin.builderValidationMeetingId'));
  if (!form.surveyType)                                   issues.push(t('admin.builderValidationSurveyType'));

  const audienceLabel = isEuropaOnly
    ? t('admin.builderEurope')
    : form.audienceOUs.length === 0
    ? t('admin.builderPublishGlobalLabel')
    : form.audienceOUs.map(k => OU_LIST.find(o => o.key === k)?.label || k).join(', ');

  const activeDaysLabel = form.activeDays.length === 7
    ? t('admin.activeDaysAll')
    : form.activeDays.length === 0
    ? '—'
    : form.activeDays.map(i => t(DAY_FULL_KEYS[i])).join(', ');

  return (
    <div className="builder-section">
      <h3><i className={isTemplate ? 'fas fa-save' : 'fas fa-rocket'} /> {t(isTemplate ? 'admin.builderReviewTemplateTitle' : 'admin.builderReviewTitle')}</h3>
      {isEuropaOnly && (
        <div className="info-banner-small europa-mode-note" style={{ marginBottom: 16 }}>
          <i className="fas fa-shield-alt" />
          <p>{t('admin.builderEuropaPublishNote')}</p>
        </div>
      )}
      <div className="publish-summary">
        <div className="publish-row">
          <span className="publish-label">{t('admin.builderPublishIdLabel')}</span>
          <span className="publish-val">
            {form.name || '—'}{' '}
            <span style={{ fontSize: '0.68rem', color: '#aaa', fontWeight: 400 }}>
              {t('admin.builderPublishInternal')}
            </span>
          </span>
        </div>
        <div className="publish-row">
          <span className="publish-label">{t('admin.builderPublishTypeLabel')}</span>
          <span className="publish-val">
            {{ general: t('admin.builderPreviewGeneral'), personalizada: t('admin.builderPreviewPersonalized'), pulso_especifica: t('admin.builderPreviewPulsoEspecifica'), '': '—' }[form.surveyType]}
          </span>
        </div>
        <div className="publish-row">
          <span className="publish-label">{t('admin.builderPublishAudienceLabel')}</span>
          <span className="publish-val">{audienceLabel}</span>
        </div>
        <div className="publish-row">
          <span className="publish-label">{t('admin.builderPublishQuestionsLabel')}</span>
          <span className="publish-val">{form.questions.length}</span>
        </div>
        <div className="publish-row">
          <span className="publish-label">{t('admin.builderPublishActiveDaysLabel')}</span>
          <span className="publish-val">{activeDaysLabel}</span>
        </div>
        <div className="publish-row">
          <span className="publish-label">{t('admin.builderPublishExpirationLabel')}</span>
          <span className="publish-val">{form.expirationDate || '—'}</span>
        </div>
        <div className="publish-row">
          <span className="publish-label">{t('admin.builderPublishAnonymityLabel')}</span>
          <span className="publish-val">
            {form.anonymous
              ? <span style={{ color: '#342F82' }}><i className="fas fa-user-secret" /> {t('admin.builderPublishAnonymousVal')}</span>
              : <span style={{ color: '#888' }}><i className="fas fa-user" /> {t('admin.builderPublishNominalVal')}</span>
            }
          </span>
        </div>
      </div>
      {issues.length > 0 ? (
        <div className="publish-issues">
          <i className="fas fa-exclamation-triangle" />
          <strong>{t(isTemplate ? 'admin.builderCompleteBeforeSave' : 'admin.builderCompleteBeforePublish')}</strong>
          <ul>{issues.map((issue, i) => <li key={i}>{issue}</li>)}</ul>
        </div>
      ) : (
        <div className="publish-ready">
          <i className="fas fa-check-circle" /> {t(isTemplate ? 'admin.builderReadyToSaveTemplate' : 'admin.builderReadyToPublish')}
        </div>
      )}
    </div>
  );
}
